import styled from 'styled-components';
import gradCap from '../assets/Grad cap.svg';
import gradCapsBottom from '../assets/grad caps.svg';
import { mediaQueries } from '../shared/config';
import { NavLink } from 'react-router-dom';
import DBLogo from './images/db.svg'
import { useState } from 'react';
import mobileImage from '../assets/Group 214.svg';

const DBHead = styled('div')`
  width: calc(100% - 2px);
  padding: 0.5em 0;
  color: black;
  font-family: 'Times New Roman';
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;
  border-style: solid;
  border-width: 1px;
`;

const GradIssueBox = styled('div')`
  font-family: 'Bebas Neue';
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  font-size: 80px;
  border-style: solid;
  border-width: 1px;
  padding: 0.1em;
  position: relative;
  ${mediaQueries.mobile} {
    font-size: 60px;
  }
  /* max-width: 80%; */
`;

const Container = styled('div')`
  display: flex;
  flex-direction: row;
  /* margin: auto auto; */
  margin-top: 50px;
  margin-bottom: 20px;
  padding-bottom: 1.5%;
  /* margin-bottom: 20px; */
  justify-content: center;
  ${mediaQueries.mobile} {
    flex-direction: column;
    width: 60%;
    margin: auto;
    margin-top: 50px;
  }
`;

const GradCapFooter = styled('img')`
/* position: bottom; */
/* bottom: 0;
margin-bottom: 0px; */
width: 100%;
/* height: 20vh; */
z-index: 0;
`;

const GradCapStyle = styled('img')`
  width: 150px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  ${mediaQueries.mobile} {
    height: 100px;
    transform: translate(80%, -70%);
  }
`;

const BackGround = styled('div')`
  /* z-index: -1; */
  height: 80vh;
  position: relative;
  background: transparent;
  margin-bottom: 8px;
  ${mediaQueries.mobile} {
    min-height: 80vh;
    height: auto;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
`;

const StyledButton = styled('button')`
  z-index: 100;
  font-family: 'Bebas Neue';
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  font-size: 35px;
  border-style: solid;
  border-width: 1.2px;
  border-color: black;
  padding: 0.2em;
  width: 40%;
  margin: auto;
  margin-top: 1%;
  /* margin-bottom: 5px; */
  margin-left: calc(50% - 20%);
  background-color: Transparent;
  outline: none;
  cursor: pointer;
  :hover& {
    z-index: 100;
    background-color: rgba(244, 236, 192);
  }
  div {
    /* opacity: 0%; */
    color: #000; /* Fallback for older browsers */
    color: rgba(0, 0, 0, 0);
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
    z-index: 100;
  }
  ${mediaQueries.mobile} {
    font-size: 25px;
    margin-top: 0;
  }
`;

let ButtonContainer = styled.div`
  z-index: 100;
`;

function geturl(title) {
  switch (title) {
    case 'STORIES':
      return 'stories';
    case 'LETTER FROM THE EDITOR':
      return 'letter';
    case 'YEAR IN REVIEW':
      return 'year-in-review';
    case 'ABOUT':
      return 'about';
  }
}

let styledBtn = (title) => {
  return (
    <ButtonContainer>
      <NavLink to={'/' + geturl(title)}>
        <StyledButton
          onClick={() => {
            console.log('Clicked!');
          }}
        >
          <div>{title}</div>
        </StyledButton>
      </NavLink>
    </ButtonContainer>
  );
};

function Landing() {
  const media = window.matchMedia('(max-width: 750px)');
  const [isMobile, setIsMobile] = useState(media.matches);

  media.addEventListener('change', () => {
    if (media.matches !== isMobile) {
      setIsMobile(media.matches);
    }
  });

  // if (isMobile)
  //   gradCap = '../assets/Group 214.svg';

  return (
    <div>
      <BackGround>
        <DBHead><img src={DBLogo} alt="Daily Bruin" /></DBHead>
        <Container>
          <GradIssueBox>
            {/* {isMobile && <GradCapStyle src={mobileImage}></GradCapStyle>} */}
            <GradCapStyle src={gradCap}></GradCapStyle>
            GRADUATION ISSUE
          </GradIssueBox>
          <GradIssueBox>2021</GradIssueBox>
        </Container>
        {styledBtn('STORIES')}
        {styledBtn('LETTER FROM THE EDITOR')}
        {styledBtn('YEAR IN REVIEW')}
        {styledBtn('ABOUT')}
      </BackGround>
      {/* <GradCapFooter src={gradCapsBottom}></GradCapFooter> */}
      {isMobile && <GradCapFooter src={mobileImage}></GradCapFooter>}
      {!isMobile && <GradCapFooter src={gradCapsBottom}></GradCapFooter>}
    </div>
  );
}

export default Landing;
